import * as types from './actionTypes';

const DEFAULT_LOOKAHEAD_PAGES = 8;

// Both execution grids are paged and sorted on the server, so each one keeps
// its own page of rows plus the lookahead pagination metadata.
const initialExecutionState = (prefix) => ({
    [`${prefix}ExecutionResults`]: [],
    [`${prefix}Loading`]: false,
    [`${prefix}LastPageFetched`]: 1,
    [`${prefix}HasNextPage`]: false,
    [`${prefix}TotalNumberOfPages`]: 0,
    [`${prefix}HasLookaheadPages`]: false,
    [`${prefix}LookaheadPages`]: 0,
});

const initialState = {
    ...initialExecutionState('fullBuild'),
    ...initialExecutionState('prBuild'),
    suiteResults: {},
    csvReports: {},
    csvLoading: false,
    error: null,
    modalOpen: false,
    selectedExecution: null
};

const executionResultsSuccess = (state, prefix, payload) => {
    const additional = payload?.additional_data || {};
    const hasLookaheadPages = Boolean(additional?.has_lookahead_pages);

    return {
        ...state,
        [`${prefix}Loading`]: false,
        [`${prefix}ExecutionResults`]: payload?.data || [],
        [`${prefix}LastPageFetched`]: parseInt(additional?.page_number) || 1,
        [`${prefix}HasNextPage`]: Boolean(additional?.has_next_page),
        [`${prefix}TotalNumberOfPages`]: parseInt(additional?.total_number_of_pages) || 0,
        [`${prefix}HasLookaheadPages`]: hasLookaheadPages,
        [`${prefix}LookaheadPages`]: hasLookaheadPages ? (parseInt(additional?.lookahead_pages) || DEFAULT_LOOKAHEAD_PAGES) : 0,
    };
};

const executionResultsFailure = (state, prefix, error) => ({
    ...state,
    [`${prefix}Loading`]: false,
    [`${prefix}ExecutionResults`]: [],
    [`${prefix}HasNextPage`]: false,
    [`${prefix}HasLookaheadPages`]: false,
    [`${prefix}LookaheadPages`]: 0,
    error
});

const AutomationTestsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_FULL_BUILD_EXECUTION_RESULTS:
            return { ...state, fullBuildLoading: true, error: null };

        case types.FETCH_PR_BUILD_EXECUTION_RESULTS:
            return { ...state, prBuildLoading: true, error: null };

        case types.FETCH_FULL_BUILD_EXECUTION_RESULTS_SUCCESS:
            return executionResultsSuccess(state, 'fullBuild', action.payload);

        case types.FETCH_PR_BUILD_EXECUTION_RESULTS_SUCCESS:
            return executionResultsSuccess(state, 'prBuild', action.payload);

        case types.FETCH_FULL_BUILD_EXECUTION_RESULTS_FAILURE:
            return executionResultsFailure(state, 'fullBuild', action.payload);

        case types.FETCH_PR_BUILD_EXECUTION_RESULTS_FAILURE:
            return executionResultsFailure(state, 'prBuild', action.payload);

        case types.FETCH_SUITE_RESULTS_SUCCESS:
            return {
                ...state,
                suiteResults: { ...state.suiteResults, [action.payload.id]: action.payload.data }
            };

        case types.FETCH_SUITE_RESULTS_FAILURE:
            return { ...state, error: action.payload };

        case types.FETCH_CSV_REPORT:
            return { ...state, csvLoading: true, error: null };

        case types.FETCH_CSV_REPORT_SUCCESS:
            return {
                ...state,
                csvLoading: false,
                csvReports: {
                    ...state.csvReports,
                    [action.payload.id]: action.payload.data
                }
            };

        case types.FETCH_CSV_REPORT_FAILURE:
            return { ...state, csvLoading: false, error: action.payload };

        case types.SET_SELECTED_EXECUTION:
            return { ...state, selectedExecution: action.payload };

        case types.SET_MODAL_OPEN:
            return { ...state, modalOpen: action.payload };

        default:
            return state;
    }
};

export default AutomationTestsReducer;
